<script>
  import {
    Card,
    Accordion,
    Button,
    Text,
    Image,
    Title,
  } from "@svelteuidev/core";
  import Constantes from "../../Classes/Constantes";
  import Conexoes from "../../Classes/Conexoes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import DropDownDB from "../../componentes_basicos/DropDownDB.svelte";
  import { permissaoUsuario } from "../../Classes/Stores";
  import TelasAcessoNaoAutorizado from "../TelasAcessoNaoAutorizado.svelte";
  import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";
  import Loading from "../../componentes_basicos/Loading.svelte";
  const conexao = new Conexoes();
  export let params;
  let id_campeonato = params;
  let isLoading = false;
  let result = [];
  let sigla = "";
  let message = "";
  let id_prova;
  let desempates = [];
  let atletaEnvio;
  let carregando;
  let salvou = [];
  let atletasAgrupados = [];
  let config_campeonato = {
    api: Constantes.api_consultar_padrao,
    parametros: {
      query_code: "consultar_todos_campeonatos",
    },
    nome_coluna_opcoes: "nome_campeonato",
    nome_coluna_saida: "id",
    filtravel: false,
    itens: "",
  };

  async function PegarDados() {
    isLoading = true;
    result = [];
    result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: Constantes.query_code_busca_movimentos_e_inscritos,
      sigla: sigla,
      id_campeonato: id_campeonato,
      id_prova: id_prova,
    });
    isLoading = false;

    let c = 0;
    result.forEach((element) => {
      if (element.publicar == "1") {
        salvou[c] = "salvo";
      } else {
        salvou[c] = "";
      }

      c++;
    });
    console.log("salvou", salvou);
    atletasAgrupados = agruparPorAtleta();
  }

  let config_drop_down_categoria = {
    api: Constantes.api_consultar_padrao,
    parametros: {
      query_code: "consulta_siglas_categorias",
      id_campeonato: id_campeonato,
    },
    nome_coluna_opcoes: "sigla_prova",
    nome_coluna_saida: "id_prova",
    filtravel: false,
    itens: "",
  };

  function RetornaDropsCategoria(e) {
    sigla = e.detail.objeto.sigla;
    id_prova = e.detail.objeto.id_prova;
    PegarDados();
  }

  async function enviarResultado() {
    //await handleToggleChange(1, atletaId, movimento, coluna);
    //isLoading = true;
    let itens = atletasAgrupados;
    let parametros = [];
    itens.forEach((element) => {
      let temp = {
        valores: element.movimentos[0],
        cod_inscricao_encurtado: element.cod_inscricao_encurtado,
        id_movimento: element.id_movimento,
      };
      parametros = [...parametros, temp];
    });
    console.log(parametros);
    carregando = true;
    const resposta = await conexao.conecta(Constantes.api_inserir_resultado, {
      body: parametros,
    });
    carregando = false;
    if (resposta && resposta.sucesso) {
      message = Constantes.msg_inserido_sucesso;
      atletasAgrupados = [];
      result = [];
      PegarDados();
    } else {
      message = Constantes.msg_erro_conexao_bd;
    }
    isLoading = false;
    console.log(resposta);
  }

  function agruparPorAtleta() {
    console.log(result);
    const agrupado = result.reduce((acc, curr) => {
      const atletaId = curr.cod_inscricao_encurtado;
      let movimento;
      if (!acc[atletaId]) {
        movimento = {
          nome_movimento: curr.nome_movimento,
          descricao_movimento: curr.descricao_movimento,

          quantidade: curr.quantidade || 0,
          tempo: curr.tempo || "",
          desempate_valor: curr.desempate_valor || 0,
          desempate_tempo: curr.desempate_tempo || "",
          publicar: curr.publicar || 0,
          publicar_definitivo: curr.publicar_definitivo || 0,
          cap: curr.cap,
          nao_participou: curr.nao_participou,
        };
        acc[atletaId] = {
          nome: curr.atletas,
          cod_inscricao_encurtado: curr.cod_inscricao_encurtado,
          nome_equipe: curr.nome_equipe,
          id_movimento: curr.id,
          movimentos: [movimento],
        };
      }
      console.log(acc[atletaId]);
      // acc[atletaId].movimentos.push(movimento);
      return acc;
    }, {});
    return Object.values(agrupado);
  }

  async function RetornaDrops(e) {
    config_drop_down_categoria = {};
    id_campeonato = "";
    await id_campeonato;
    id_campeonato = e.detail.objeto.id;
    config_drop_down_categoria = {
      api: Constantes.api_consultar_padrao,
      parametros: {
        query_code: "consulta_siglas_categorias",
        id_campeonato: id_campeonato,
      },
      nome_coluna_opcoes: "sigla_prova",
      nome_coluna_saida: "id_prova",
      filtravel: false,
      itens: "",
    };
  }
</script>

<br />
<br />
<br />
<br />

{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_inserir_resultado)}
  <CaixaDeDialogo {message} on:close={() => (message = "")} />
  <LoadingTela {isLoading} />
  <div class="container">
    {#if !params}
      <label>Selecione o campeonato</label>
      <DropDownDb config={config_campeonato} on:retorno={RetornaDrops} />
    {/if}
    {#if id_campeonato}
      <label>Selecione a categoria/prova</label>
      <DropDownDB
        config={config_drop_down_categoria}
        on:retorno={RetornaDropsCategoria}
      />
      {#if result.length > 0}
        <Title order={3}>Categoria: {result[0].nome_categoria}</Title>
        <Title order={4}>Prova: {result[0].nome_prova}</Title>
        <p>{result[0].descricao_prova}</p>
        <div class="tabela-container">
          {#each atletasAgrupados as atleta, idx}
            <div class="atleta-bloco">
              <div class="atleta-info">
                <strong>Atleta:</strong>
                {atleta.nome}<br />
                {#if atleta.nome_equipe}
                  <strong>Equipe:</strong> {atleta.nome_equipe}<br />
                {/if}
                <div class="codigo_pequeno">
                  Inscrição: {atleta.cod_inscricao_encurtado}
                </div>
              </div>
              {#if salvou.length > 0}
                {#each atleta.movimentos as movimento}
                  <div class="tabela-linha {salvou[idx]}">
                    <div class="tabela-item">
                      <h5>
                        <strong>Movimento:</strong>
                        {movimento.nome_movimento}
                      </h5>
                      <strong>Descrição:</strong>
                      {movimento.descricao_movimento}
                    </div>
                    <div class="tabela-bloco">
                      <div class="bloco-linha">
                        <label>Pontos:</label>
                        <input
                          type="number"
                          bind:value={movimento.quantidade}
                        />
                      </div>
                      <div class="bloco-linha">
                        <label>Tempo (mm:ss):</label>
                        <input type="time" bind:value={movimento.tempo} />
                      </div>
                      {#if desempates[idx]}
                        <div class="bloco-linha">
                          <label>Cap:</label>
                          <input type="number" bind:value={movimento.cap} />
                        </div>
                        <div class="bloco-linha">
                          <label>Ponto desempate:</label>
                          <input
                            type="number"
                            bind:value={movimento.desempate_valor}
                          />
                        </div>
                        <div class="bloco-linha">
                          <label>Tempo desempate:</label>
                          <input
                            type="time"
                            bind:value={movimento.desempate_tempo}
                          />
                        </div>
                      {/if}
                    </div>

                    <div class="publicar-checkboxes">
                      <label>
                        <input
                          type="checkbox"
                          on:change={(e) =>
                            (desempates[idx] = !desempates[idx])}
                        />
                        Inserir desempates
                      </label>
                      <label>
                        {#if movimento.nao_participou == 1}
                          <input
                            type="checkbox"
                            checked={movimento.nao_participou}
                            on:change={(e) => {
                             
  
                            

                              if (e.target.checked ) {
                                movimento.nao_participou=1;
                                movimento.quantidade = 0;
                                movimento.tempo = 0;
                                movimento.desempate_tempo = 0;
                                movimento.desempate_valor = 0;
                              }else{
                                 movimento.nao_participou=0;
                              }
                            }}
                          />
                        {:else}
                          <input
                            type="checkbox"
                            on:change={(e) => {
                               if (e.target.checked ) {
                                movimento.nao_participou=1;
                                movimento.quantidade = 0;
                                movimento.tempo = 0;
                                movimento.desempate_tempo = 0;
                                movimento.desempate_valor = 0;
                              }else{
                                 movimento.nao_participou=0;
                              }
                            }}
                          />{/if}
                        Não participou
                      </label>
                      <label>
                        {#if movimento.publicar == 1}
                          <input
                            type="checkbox"
                            checked={movimento.publicar}
                            on:change={(e) =>
                              (movimento.publicar = e.target.checked
                                ? "1"
                                : "0")}
                          />
                        {:else}
                          <input
                            type="checkbox"
                            on:change={(e) =>
                              (movimento.publicar = e.target.checked
                                ? "1"
                                : "0")}
                          />{/if}
                        Publicar
                      </label>

                      <Loading {carregando} />
                      <!--
                    <label>
                      <input type="checkbox" checked={movimento.publicar_definitivo} on:change={(e) => handleToggleChange(e, atleta.cod_inscricao_encurtado, movimento.nome_movimento, "publicar_definitivo")} />
                      Publicar Definitivo
                    </label>

                    -->
                    </div>
                  </div>
                {/each}
              {/if}
            </div>
          {/each}
          <button on:click={(e) => enviarResultado()}>Salvar</button>
        </div>
      {/if}
    {/if}
  </div>
{:else}
  <TelasAcessoNaoAutorizado />
{/if}
<br />
<br />
<br />
<br />

<style>
  .tabela-container {
    margin-top: 20px;
  }

  .atleta-bloco {
    border-bottom: 1px solid #ccc;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }

  .codigo_pequeno {
    font-size: 0.9rem;
    color: #888;
  }

  .tabela-linha {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 10px;
    margin: 10px 0;
    background: #f4f4f4;
    border-radius: 6px;
  }
  .salvo {
    background-color: aquamarine;
  }
  .tabela-item {
    flex: 1 1 100%;
    padding: 5px;
    font-size: 0.95rem;
  }

  .tabela-bloco {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .bloco-linha {
    display: flex;
    flex-direction: column;
    width: 150px;
  }

  .publicar-checkboxes {
    display: flex;
    gap: 20px;
    margin-left: 20px;
  }
</style>
